import { write } from "./write"

export const eventLog = {
  write,
}
